import React from "react";
import "./stars.css";
import bluegingham from "../assets/bluegingham.jpg";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

function Stars() {
  const md = `
# Waist to Waist with M

i can be of little comfort 

I had nothing but admiration for you

I want me to disappear too

you know where to find me 
`;

  return (
  <div
    className="stars-page"
    style={{
      backgroundImage: `url(${bluegingham})`,
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      backgroundPosition: "top left",
      minHeight: "250vh",
    }}
  >
    <article className="stars-text">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {md}
      </ReactMarkdown>
    </article>
  </div>
);
}

export default Stars;
